import {
  SELECT_PORTFOLIO,
  ON_PORTFOLIO_DASHBOARD,
  ON_PORTFOLIO_DASHBOARD_SUCCESS,
  ADD_FAVOURITE_PORTFOLIO,
  ADD_FAVOURITE_PORTFOLIO_SUCCESS,
  FETCH_PORTFOLIO,
  FETCH_PORTFOLIO_SUCCESS,
  FETCH_ALL_PORTFOLIO,
  FETCH_ALL_PORTFOLIO_SUCCESS,
  FILTER_PORTFOLIO,
  GET_ALL_PORTFOLIO,
  GET_UNSELECTED_ALL_PORTFOLIO,
  HANDLE_PORTFOLIO_REQUEST_CLOSE,
  HIDE_PORTFOLIO_LOADER,
  SHOW_PORTFOLIO_LOADER,
  ON_ADD_PORTFOLIO,
  ON_EDIT_PORTFOLIO,
  ON_ALL_PORTFOLIO_SELECT,
  ON_PORTFOLIO_CLOSE,
  ON_PORTFOLIO_SELECT,
  ON_DELETE_PORTFOLIO,
  ON_DELETE_PORTFOLIO_SUCCESS,
  ON_FILTER_SELECTED_PORTFOLIO,
  ON_FILTER_PORTFOLIO_OPTION_SELECT,
  ON_SAVE_PORTFOLIO,
  ON_SAVE_PORTFOLIO_SUCCESS,
  ON_TOGGLE_PORTFOLIO_DRAWER,
  SHOW_PORTFOLIO_MESSAGE,
  UPDATE_SEARCH_PORTFOLIO,
} from 'constants/ActionTypes';

export const selectPortfolio = (payload) => {
  return {
      type: SELECT_PORTFOLIO,
      payload
  };
};
export const onPortfolioDashboard = (payload) => {
  return {
      type: ON_PORTFOLIO_DASHBOARD,
      payload,
  };
};
export const onPortfolioDashboardSuccess = (payload) => {
  return {
      type: ON_PORTFOLIO_DASHBOARD_SUCCESS,
      payload,
  };
};
export const fetchPortfolio = (payload) => {
  return {
      type: FETCH_PORTFOLIO,
      payload
  };
};
export const fetchPortfolioSuccess = (payload) => {
  return {
      type: FETCH_PORTFOLIO_SUCCESS,
      payload
  };
};
export const fetchPortfolios = () => {
  return {
      type: FETCH_ALL_PORTFOLIO
  };
};
export const fetchPortfoliosSuccess = (payload) => {
  return {
      type: FETCH_ALL_PORTFOLIO_SUCCESS,
      payload
  };
};
export const showPortfolioMessage = (message) => {
  return {
      type: SHOW_PORTFOLIO_MESSAGE,
      payload: message
  };
};
export const addFavouritePortfolio = (payload) => {
  return {
      type: ADD_FAVOURITE_PORTFOLIO,
      payload
  };
};
export const addFavouritePortfolioSuccess = (payload) => {
  return {
      type: ADD_FAVOURITE_PORTFOLIO_SUCCESS,
      payload
  };
};
export const onPortfolioSelect = (payload) => {
  return {
      type: ON_PORTFOLIO_SELECT,
      payload
  };
};
export const onAddPortfolio = () => {
  return {
      type: ON_ADD_PORTFOLIO,
  };
};
export const onEditPortfolio = (payload) => {
  return {
      type: ON_EDIT_PORTFOLIO,
      payload
  };
};
export const onPortfolioClose = () => {
  return {
      type: ON_PORTFOLIO_CLOSE,
  };
};
export const onFilterPortfolioOptionSelect = (payload) => {
  return {
      type: ON_FILTER_PORTFOLIO_OPTION_SELECT,
      payload
  };
};
export const onSavePortfolio = (payload) => {
  return {
      type: ON_SAVE_PORTFOLIO,
      payload
  };
};
export const onSavePortfolioSuccess = (data) => {
  return {
      type: ON_SAVE_PORTFOLIO_SUCCESS,
      payload: data
  };
};
export const onDeletePortfolio = (payload) => {
  return {
      type: ON_DELETE_PORTFOLIO,
      payload
  };
};
export const onDeletePortfolioSuccess = (payload) => {
  return {
      type: ON_DELETE_PORTFOLIO_SUCCESS,
      payload
  };
};
export const onFilterSelectedPortfolio = () => {
  return {
      type: ON_FILTER_SELECTED_PORTFOLIO,
      payload: ''
  };
};
export const filterPortfolio = (payload) => {
  return {
      type: FILTER_PORTFOLIO,
      payload
  };
};
export const getAllPortfolio = () => {
  return {
      type: GET_ALL_PORTFOLIO,
      payload: ''
  };
};
export const getUnselectedAllPortfolio = () => {
  return {
      type: GET_UNSELECTED_ALL_PORTFOLIO,
      payload: ''
  };
};
export const onAllPortfolioSelect = () => {
  return {
      type: ON_ALL_PORTFOLIO_SELECT,
      payload: ''
  };
};
export const updateSearchPortfolio = (payload) => {
  return {
      type: UPDATE_SEARCH_PORTFOLIO,
      payload
  };
};
export const onTogglePortfolioDrawer = () => {
  return {
      type: ON_TOGGLE_PORTFOLIO_DRAWER,
  };
};
export const handlePortfolioRequestClose = () => {
  return {
      type: HANDLE_PORTFOLIO_REQUEST_CLOSE,
  };
};
export const showPortfolioLoader = () => {
  return {
      type: SHOW_PORTFOLIO_LOADER,
  };
};
export const hidePortfolioLoader = () => {
  return {
      type: HIDE_PORTFOLIO_LOADER,
  };
};



// WEBPACK FOOTER //
// ./actions/portfolio.js